<template>
    <LayoutSub className="pb-0 electronic">
        <SubpageTitleContainer
            :title="`이지뱅킹(EasyBanking)`"
            :subText="`은행과 연결된 KICC의 전산망을 통해 지급, 자동이체 수납, 실시간 출금, 대량 입금, 가상계좌 수납  등의 기업 금융거래를 자동화하여 처리할 수 있는 서비스입니다.`"
        >
            <RedLineButton :type="`outbound`" :text="`서비스 상담`" @click="modalOpen()" />
        </SubpageTitleContainer>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">서비스 종류</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid
                    title="출금이체"
                    content="서비스 구독료, 월 이용료 등 기업이 수납해야 할 자금을 다수의 계좌에서 출금하여 기업계좌로 입금하는 서비스입니다."
                    src="sub03_icon01.png"
                />
                <TableRow_2grid
                    title="입금(지급)이체"
                    content="급여지급, 배당금, 보험료 및 대출금 입금, 환불대금 지급 등 기업이 지급해야 할 각종 자금을 기업계좌에서 출금하여 다수의 계좌로 입금하는 서비스입니다."
                    src="sub03_icon02.png"
                />
                <TableRow_2grid
                    title="가상계좌"
                    content="하나의 실계좌에 연결된 다수의 가상계좌(입금전용계좌)를 이용기관에 부여하고, 고객님의 납부 및 결제가 필요할 때 가상계좌로 입금 요청하여 입금내역을 실시간으로 확인할 수 있는 서비스입니다."
                    src="sub03_icon03.png"
                />
                <TableRow_2grid
                    title="예금 거래내역 조회"
                    content="각 은행의 뱅킹 로그인 없이 보유한 계좌의 거래내역을 확인할 수 있는 서비스입니다."
                    src="sub03_icon04.png"
                />
                <TableRow_2grid
                    title="예금주 성명조회"
                    content="유효한 계좌인지 검증하고, 계좌 예금주명 일치 여부를 확인하여 입출금 사고를 방지하는 서비스입니다."
                    src="sub03_icon05.png"
                />
                <TableRow_2grid
                    title="계좌 잔액 조회"
                    content="각 은행의 뱅킹 로그인 없이 보유한 계좌의 잔액을 확인할 수 있는 서비스입니다."
                    src="sub03_icon06.png"
                />
                <TableRow_2grid
                    title="현금영수증 발급 대행"
                    content="현금 결제 내역을 국세청으로 전송하여 현금영수증을 지출 증빙 또는 소득공제용으로 발행하고 관리할 수 있는 서비스입니다."
                    src="sub03_icon07.png"
                />
                <TableRow_2grid
                    title="세금계산서 발행 대행"
                    content="국세청과 연동하여 세금계산서를 발행하고 관리할 수 있는 서비스입니다."
                    src="sub03_icon08.png"
                />
            </div>
        </SubSection>

        <SubSection>
            <SubTitle3 listStyle="dot">도입 효과</SubTitle3>
            <div class="table-3grid">
                <TableRow_3grid
                    title="업무 효율성 제고"
                    :list="['업무 자동화로 수납에 소요되는 시간 및 제반업무 비용 절감', '자체 시스템 구축 및 별도의 시스템 운영인력 불필요']"
                    src="sub03_2_icon01.png"
                />
                <TableRow_3grid
                    title="편의성 증대"
                    :list="['비용 납부를 편리하게 해 고객 편의성 증대 및 서비스 지속성 유지', '업무 자동화로 수납 오류 방지 및 효율적 관리 가능']"
                    src="sub03_2_icon02.png"
                />
                <TableRow_3grid
                    title="자금계획 용이"
                    :list="['타 결제수단보다 빠른 정산 주기', '정기적이고 규칙적인 자금 수납/이체로 계획성 있는 <br />자금 운용 가능']"
                    src="sub03_2_icon03.png"
                />
            </div>
        </SubSection>

        <SubSection type="wide" class="pb-160">
            <SubTitle3 listStyle="dot">서비스 신청 안내</SubTitle3>
            <div class="grid-3">
                <CardBox3 idx="1" title="서비스 신청" content="서비스 신청을 위해 아래 버튼을 눌러주세요.<br />담당자 확인 후 안내드리겠습니다.">
                    <OrangeLineButton text="서비스 신청" @click="modalOpen()" />
                </CardBox3>
                <CardBox3
                    idx="2"
                    title="서비스 상담"
                    content="서비스 도입 범위 및 방식, 보증보험 가입 금액 협의 등 <br />서비스 도입을 위한 협의 및 상담이 진행됩니다."
                />
                <CardBox3
                    idx="3"
                    title="계약 체결 및 구비서류 제출"
                    content="안내 받으신 계약서와 이용 신청서 등의 구비서류를 <br />작성 양식에 맞춰 작성하신 후 우편으로 발송해주세요."
                />
                <CardBox3 idx="4" title="금융기관 심사" content="각 은행별 심사가 진행되며,<br />소요 기간은 각 은행사마다 상이합니다." />
                <CardBox3
                    idx="5"
                    title="서비스 연동 개발"
                    content="금융기관 심사가 완료되면, 협의된 업무 범위와 방식에 따라 <br />서비스 연동을 위한 개발이 진행됩니다."
                />
                <CardBox3
                    idx="6"
                    title="서비스 오픈"
                    content="서비스 오픈 전 백오피스 관리자 아이디 및 이용기관 매뉴얼이 <br />제공되며 추가적인 서류가 요구될 수 있습니다."
                />
            </div>
        </SubSection>
    </LayoutSub>

    <div class="modal_container electonicFinace" v-if="modalCheck" @click.stop>
        <div class="modal_wrapper modal" @click.stop>
            <div class="modal_header">
                <p>EasyBanking 서비스 상담</p>
                <button class="modal_close" @click="modalOpen">
                    <img src="@/assets/ic_close.png" alt="" />
                </button>
            </div>
            <div class="modal_body" data-lenis-prevent>
                <LoadingWrap v-if="submitInquiryLoading" />
                <div class="modal_content" v-else>
                    <div class="content_body">
                        <section>
                            <div class="modal_row">
                                <div class="input_group require">
                                    <span>회사명</span>
                                    <input type="text" placeholder="ex) 한국정보통신" ref="comName" />
                                </div>
                            </div>
                            <div class="modal_row">
                                <div class="input_group require">
                                    <span>담당자명</span>
                                    <input type="text" placeholder="ex) 김담당" ref="picName" />
                                </div>
                                <div class="input_group">
                                    <span>부서명</span>
                                    <input type="text" placeholder="ex) 디지털기획부" ref="department" />
                                </div>
                            </div>
                            <div class="modal_row">
                                <div class="input_group require">
                                    <span>연락처</span>
                                    <input type="text" inputmode="numeric" placeholder="ex) 01012345678 (- 제외)" ref="hpNo" @input="allowOnlyNumbers" />
                                </div>
                                <div class="input_group require">
                                    <span>이메일</span>
                                    <input type="text" placeholder="ex) easybanking@kicc.co.kr" ref="email" />
                                </div>
                            </div>
                        </section>
                        <section>
                            <p class="section_title">문의내용</p>
                            <label for="a">
                                <input type="radio" name="radio_01" id="a" @change="etcChecker" valueText="출금이체" />
                                <span class="radio"></span>
                                <span>출금이체 (ex. 서비스 구독료, 월 이용료 등 자동이체)</span>
                            </label>
                            <label for="b">
                                <input type="radio" name="radio_01" id="b" @change="etcChecker" valueText="입금(지급)이체" />
                                <span class="radio"></span>
                                <span>입금(지급)이체 (ex. 급여 지급, 배당금, 환불대금 지급 등)</span>
                            </label>
                            <label for="c">
                                <input type="radio" name="radio_01" id="c" @change="etcChecker" valueText="가상계좌" />
                                <span class="radio"></span>
                                <span>가상계좌</span>
                            </label>
                            <label for="d">
                                <input ref="etc" type="radio" name="radio_01" id="d" @change="etcChecker" valueText="기타" />
                                <span class="radio"></span>
                                <span>기타</span>
                                <input v-if="etcCheck" type="text" name="" id="" placeholder="기타 문의사항을 입력해주세요" ref="etcText" />
                            </label>
                        </section>
                        <section>
                            <p class="section_title require">개인정보 수집 이용에 대한 안내</p>
                            <label for="e">
                                <input type="checkbox" name="e" id="e" @change="etcChecker" ref="personalYn" />
                                <span class="radio"></span>
                                <span>개인정보 수집 및 이용 동의</span>
                            </label>
                            <div :class="['infor_box', modalFold ? 'fold' : '']">
                                <p class="infor_title" @click="toggleModal">
                                    <span>필수 수집 이용 항목</span>
                                    <i>
                                        <img src="@/assets/list_dropdown_icon.png" alt="" />
                                    </i>
                                </p>
                                <p class="infor_desc">서비스 신청 및 상담을 위해 최소한의 개인정보활용 동의가 필요합니다.</p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>수집항목</th>
                                            <td>(필수) 회사명, 담당자명, 이메일주소, 연락처, 문의내용, (선택) 부서명</td>
                                        </tr>
                                        <tr>
                                            <th>목적</th>
                                            <td>서비스 신청 및 상담에 대한 회신, 문의 이용기록 조회</td>
                                        </tr>
                                        <tr>
                                            <th>보유기간</th>
                                            <td>문의 답변일로부터 1개월 내 파기</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        <section class="button_wrap">
                            <button @click="modalOpen">취소</button>
                            <button @click="submitInquiry">확인</button>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { inquiryInsert } from '@/api';
import CardBox3 from '@/components/CardBox3.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import TableRow_3grid from '@/components/TableRow_3grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    data() {
        return {
            modalCheck: false,
            modalFold: false,
            etcCheck: false,
            inquiry: null,
            submitInquiryLoading: false,
        };
    },
    components: {
        SubpageTitleContainer,
        RedLineButton,
        TableRow_2grid,
        TableRow_3grid,
        SubTitle3,
        CardBox3,
        OrangeLineButton,
        LayoutSub,
        SubSection,
        LoadingWrap,
    },
    methods: {
        modalOpen() {
            this.modalCheck = !this.modalCheck;
            // if (this.modalCheck) this.$lenis.stop();
            // else this.$lenis.start();
        },
        etcChecker(e) {
            if (e.target.name === 'radio_01') {
                this.inquiry = e.target.getAttribute('valueText');
                this.etcCheck = this.$refs.etc.checked;
            }
        },
        toggleModal() {
            this.modalFold = !this.modalFold;
        },
        checkValidation(domRef, regConfig) {
            //input필드의 입력값에 대한 별도 검증 함수
            const name = domRef.closest('.input_group').querySelector('span').textContent;

            if (domRef?.value === '') {
                alert(`${name}을(를) 입력해주세요.`);
                domRef.focus();
                return false;
            }

            if (regConfig?.regEXP) {
                if (!regConfig.regEXP.test(domRef?.value)) {
                    alert(regConfig.errMsg);
                    domRef.focus();
                    return false;
                }
            }

            return true;
        },
        allowOnlyNumbers(e) {
            e.target.value = e.target.value.replace(/\D/g, '');
        },

        async submitInquiry() {
            // 정규식 표현
            const { comName, picName, email, hpNo, etcText, personalYn } = this.$refs;
            const regConfig = {
                businessNumber: {
                    regEXP: /^\d{10}$/,
                    errMsg: "사업자번호는 '-'를 제외한 숫자 10자리로 입력해주세요.",
                },
                userName: {
                    regEXP: /^[가-힣a-zA-Z]{2,}$/,
                    errMsg: '담당자명은 한글 또는 영문 2자 이상으로 입력해주세요.',
                },
                email: {
                    regEXP: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
                    errMsg: '이메일 형식에 맞춰 입력해주세요.',
                },
            };

            if (!this.checkValidation(comName)) return;
            if (!this.checkValidation(picName, regConfig.userName)) return;
            if (!this.checkValidation(hpNo)) return;
            if (!this.checkValidation(email, regConfig.email)) return;
            if (this.inquiry === null) return alert('문의내용을 체크해주세요.');
            if (this.etcCheck && (!etcText || etcText.value.trim() === '')) {
                return alert('기타 문의사항을 입력해주세요.');
            }
            if (!personalYn?.checked) return alert('개인정보 수집 및 이용 동의에 체크해주세요.');

            const formData = new FormData();
            formData.append(
                'financeInquiry',
                JSON.stringify({
                    shopNm: comName.value,
                    name: picName.value,
                    department: this.$refs.department.value,
                    hpNo: hpNo.value,
                    email: email.value,
                    inquiry: `${this.inquiry}${etcText?.value ? `: ${etcText.value}` : ``}`,
                    personalYn: personalYn?.checked ? 'Y' : 'N',
                })
            );

            if (this.submitInquiryLoading) return;
            this.submitInquiryLoading = true;

            try {
                await inquiryInsert(formData);

                comName.value = '';
                picName.value = '';
                if (this.$refs.department) this.$refs.department.value = '';
                hpNo.value = '';
                email.value = '';
                if (etcText) etcText.value = '';
                personalYn.checked = false;
                const inquiryBtn = document.querySelectorAll('input[name="radio_01"]');
                inquiryBtn.forEach((radio) => {
                    radio.checked = false;
                });
                this.inquiry = null;
                this.etcCheck = false;

                this.submitInquiryLoading = false;
                alert('상담 문의가 제출되었습니다.');
            } catch (err) {
                console.log(err);
                this.submitInquiryLoading = false;
                alert('문의 제출이 되지 않았습니다.');
            }
        },
    },
    watch: {
        modalCheck: function () {
            if (this.modalCheck) this.$lenis.stop();
            else this.$lenis.start();
        },
    },
};
</script>
